import { inject, Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Season } from '@/shared/models/season.model';
import { GET_SEASONS } from '@/shared/services/queries/seasons.graphql';

@Injectable({
  providedIn: 'root',
})
export class SeasonsService {
  private readonly apollo = inject(Apollo);
  getSeasons(): Observable<Season[]> {
    return (
      this.apollo
        .watchQuery({
          query: GET_SEASONS,
        })
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .valueChanges.pipe(map((result: any) => result.data.seasons))
    );
  }
}
